"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldCounterWarning = exports.FieldCounter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fieldAttrsUtils = require("./fieldAttrsUtils");

var _Transition = require("../animate/Transition");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Use for static display of the counter textarea/message field
 */
var FieldCounter = function FieldCounter(_ref) {
  var announceCounter = _ref.announceCounter,
      counterAriaLabel = _ref.counterAriaLabel,
      current = _ref.current,
      id = _ref.id,
      isAssertive = _ref.isAssertive,
      isInvalid = _ref.isInvalid,
      maxLength = _ref.maxLength;

  var counterProps = _objectSpread({}, (0, _fieldAttrsUtils.counterAttributes)({
    id: id,
    isInvalid: isInvalid
  }), {
    'aria-label': counterAriaLabel(current, maxLength)
  });

  if (announceCounter) {
    counterProps['aria-live'] = isAssertive ? 'assertive' : 'polite';
    counterProps['aria-relevant'] = 'additions text';
  }

  var countDisplay = "".concat(current, "/").concat(maxLength);
  return _react.default.createElement("span", counterProps, countDisplay);
};

exports.FieldCounter = FieldCounter;
FieldCounter.defaultProps = {
  announceCounter: true,
  isAssertive: false,
  isInvalid: false
};
FieldCounter.propTypes = {
  announceCounter: _propTypes.default.bool,
  current: _propTypes.default.number.isRequired,
  id: _propTypes.default.string.isRequired,
  isAssertive: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  maxLength: _propTypes.default.number.isRequired,
  counterAriaLabel: _propTypes.default.func.isRequired
};
/**
 * The field max counter used wherever it should show/hide.
 *
 * NOTE: the counterAriaLabel prop should return a translated message
 * constructed using passed arguments: current, maxLength
 * Example:
 *      (current, maxLength) => `${current} characters used out of ${maxLength}`
 */

var FieldCounterWarning = function FieldCounterWarning(_ref2) {
  var id = _ref2.id,
      current = _ref2.current,
      maxLength = _ref2.maxLength,
      isInvalid = _ref2.isInvalid,
      counterAriaLabel = _ref2.counterAriaLabel,
      showCounter = _ref2.showCounter;
  var counterProps = {
    id: id,
    current: current,
    maxLength: maxLength,
    isInvalid: isInvalid,
    counterAriaLabel: counterAriaLabel
  };
  return _react.default.createElement(_Transition.Transition, null, showCounter && _react.default.createElement(FieldCounter, _extends({}, counterProps, {
    key: "".concat(id, "-").concat(showCounter)
  })));
};

exports.FieldCounterWarning = FieldCounterWarning;
FieldCounterWarning.defaultProps = {
  isInvalid: false,
  showCounter: false
};
FieldCounterWarning.propTypes = {
  current: _propTypes.default.number.isRequired,
  id: _propTypes.default.string.isRequired,
  isInvalid: _propTypes.default.bool,
  maxLength: _propTypes.default.number.isRequired,
  showCounter: _propTypes.default.bool.isRequired,
  counterAriaLabel: _propTypes.default.func.isRequired
};